import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasGroupingSchema = withDefaults({
  type: 'tas-grouping',
  fields: [
    {
      kind: 'attribute',
      name: 'memberId',
    },
    {
      kind: 'belongsTo',
      name: 'tasGroup',
      type: 'tas-group',
      options: {
        async: false,
        inverse: 'tasGroupings',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: 'tasGroupings',
        polymorphic: true,
      },
    },
  ],
});

export default TasGroupingSchema;
